// Modules
import {FC} from "react";
import wrapper from "redux/store";
import {Provider} from "react-redux";

// Imported definitions
import type { AppProps } from "next/app";

// styles
import "styles/main.min.css";
import "styles/searchBar.css";
import "styles/wkSearchBarApp.css";
import "styles/pagination.css";
import "styles/wk-icons-all-filled.css";
import "styles/wk-icons-all-open.css";
import "styles/corporateHat.css";
import "styles/thankYouPage.css";

// Components
import MainLayout from "components/MainLayout";

// Types
import { AppPropsWithLayout } from "interfaces/shared/page";

const App: FC<AppProps> = ({Component, ...rest}: AppPropsWithLayout) => {
	const {store, props} = wrapper.useWrappedStore(rest);

	const getLayout = Component.getLayout ?? ((page) => <MainLayout>{page}</MainLayout>);

	return (
		<Provider store={store}>
			{getLayout(<Component {...props.pageProps} />)}
		</Provider>
	);
};

export default App;
